import React from 'react'
import Form from '~/components/form'

export const Header: React.FC = () => {
  return (
    <div className='onlinepbx__partners__header'>
      <div className='onlinepbx__container'>
        <h1 className='onlinepbx__partners__header__header'>
          Зарабатывайте <span className='onlinepbx__content__header__green'><b>до 20%</b></span> от оплат клиентов
        </h1>
        <div className="onlinepbx__partners__header__text">
          с партнерской программой <span
            className='onlinepbx__content__header__green'>online</span>
          <span
            className='onlinepbx__content__header__black'>pbx</span>
        </div>
        <div className='onlinepbx__partners__form__block'>
          <Form text='Стать партнером' pageName='Партнерам' />
          <a className="onlinepbx__partners__header__link" href='https://partners.onlinepbx.ru/' target='_blank'>Войти в кабинет партнера</a>
        </div>
      </div>
    </div>
  )
}

export default Header
